import './App.css';
import './input.css';
import Page from './pages/dashboard/page';
import Login from './pages/login/login';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([
  { path: '/', element: <Login /> },
  { path: '/home', element: <Page /> },
  { path: '*', element: <Login /> },
]);
function App() {
  return <RouterProvider router={router} />;
}

export default App;
